import React from 'react';
import styled from 'styled-components';
import { seleccionar_CuentaContable } from '../../../../actions/contabilidad/act_con02';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const ContainerTreeNode = styled.div`
    overflow-y: hidden;
    :hover {
        background-color: #eaebed;
        border-radius: 1px;
    };
`;

const ContainerCollapseNode = styled.div`
    margin-right: 5px;
    display: inline;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 12px;
    cursor: pointer;
`;

const ContainerSubNodos = styled.div`
    margin-left: 10px;
    height: ${props => (props.isCollapsed?'auto':'0px')};
    font-size: 11px;
    padding: 0px;
`;

const ContainerNode = styled.div`
    margin-left: 15px;
`;

const EtiquetaNodo = styled.label`
    display: inline;
    margin-left: 5px;
    font-size: 12px;
    font-weight: ${props => (props.isNodoAgrup?'600':'500')};
    padding: 0px 10px;
    :hover {
        background-color: white;
        border-radius: 1px;
    }
`;

class TreeNode extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isCollapsed: false
        }
        this.handleClick = this.handleClick.bind(this);
        this.seleccionarNodo = this.seleccionarNodo.bind(this);
    }

    handleClick(){
        this.setState({isCollapsed: !this.state.isCollapsed});
    }

    seleccionarNodo(){
        try {
            this.props.seleccionar_CuentaContable(this.props.datosCta.Cuenta);
        } catch (error) {
            alert(`Ocurrió un error al seleccionar la cuenta. Error: ${error}`);
        }
    }

    render(){
        const {
            datosCta
        } = this.props;

        let subTreeNode = null;
        if (datosCta.SubCuentas.length>0) {
            subTreeNode = datosCta.SubCuentas.map((childNode)=> {
                            return <TreeNode seleccionar_CuentaContable={this.props.seleccionar_CuentaContable} key={childNode.Id} datosCta={childNode}/>
                        });
        }
        
        if (subTreeNode){
            return(
                <ContainerTreeNode>
                    <ContainerCollapseNode onClick={this.handleClick}>
                        <i className={`fa ${this.state.isCollapsed?'fa-minus-square':'fa-plus-square'}`} aria-hidden='true'/>
                    </ContainerCollapseNode>
                    <EtiquetaNodo isNodoAgrup={true} onClick={this.seleccionarNodo}>
                        {`${datosCta.Cuenta.Cuenta} - ${datosCta.Cuenta.Nombre}`}
                    </EtiquetaNodo>
                    <ContainerSubNodos isCollapsed={this.state.isCollapsed}>
                        {subTreeNode}
                    </ContainerSubNodos>
                </ContainerTreeNode>
            )
        }else{
            return(
                <ContainerNode>
                    <EtiquetaNodo onClick={this.seleccionarNodo}>
                        {`${datosCta.Cuenta.Cuenta} - ${datosCta.Cuenta.Nombre}`}
                    </EtiquetaNodo>
                </ContainerNode>
            )
        }
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ seleccionar_CuentaContable }, dispatch)
});
  
export default connect (null, mapDispatchToProps)(TreeNode);